import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { baseUrl } from "../Common/data";
import './SearchHotel.css';


const SearchHotel = () => {
  const [searchText, setSearchText] = useState("");
  const [results, setResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (searchText.trim()) {
        fetchSearchResults(searchText);
      } else {
        setResults([]);
      }
    }, 400);

    return () => clearTimeout(delayDebounce);
  }, [searchText]);

  const fetchSearchResults = async (query) => {
    try {
      setIsSearching(true);
      const res = await axios.get(`${baseUrl}/api/hotel/search?q=${query}`);
      const hotels = res.data.data || [];
      setResults(hotels.slice(0, 5));
      setError("");
    } catch (err) {
      console.error(err);
      setError("Something went wrong.");
    } finally {
      setIsSearching(false);
    }
  };

  const handleResultClick = (id) => {
    navigate(`/collectiondetail/${id}`);
  };

  return (
    <div className="explore-search">
      <div className="explore-search-box">
        <input
          placeholder="Search Property"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
        <button disabled><i style={{cursor:'pointer'}} class="bi bi-search"></i></button>
      </div>
      <br />
      {/* {isSearching && <p className="search-status">Loading...</p>} */}
      {error && <p className="search-error">{error}</p>}

      {results.length > 0 && (
        <div className="search-results">
          {results.map((hotel) => (
            <div
              key={hotel._id}
              className="search-result-item"
              onClick={() => handleResultClick(hotel._id)}
            >
              <h4>{hotel.propertyName}</h4>
              <p>{hotel.location?.city}, {hotel.state}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SearchHotel;
